/** 메인 화면 Mixin */
import { mapGetters } from 'vuex';
import { checkTimeCard } from '@/api/main';
import routerConstants from '@/const/routerConstants';

export default {
  props: {
    authGubun: {
      type: String,
    },
  },

  computed: {
    ...mapGetters('MENU', [
      'GET_WIDGET_USE_OBJ',

      'GET_PLAN_AB_FLAG',
      'GET_MAIN_SHOW_FLAG',

      'GET_APPL_MENU_USE_YN',

      'GET_IN_OUT_INFO',
      'GET_PSNL_WORK_INFO',
      'GET_APPR_DOC_CNT',
      'GET_EMP_LIST_BY_ORG',
      'GET_ORG_WORK_WIDGET_GUBUN',
      'GET_MATERNITY_REST_CNT',
      'GET_WORK_OVER_REST_TIME',
      'GET_HOL_WORK_LIST',
    ]),
    ...mapGetters('SPINNER', ['GET_COMMON_LOADING_STATUS']),
  },

  watch: {
    GET_PSNL_WORK_INFO() {
      // +. 공통 스피너 OFF
      this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
    },
  },

  methods: {
    /* 출퇴근처리 */
    async saveTimecard() {
      try {
        const response = await checkTimeCard({
          gubun: this.GET_IN_OUT_INFO.inOutGubun,
        });
        this.resultMap = response.data;
        if (this.resultMap.message === 'OK') {
          alert('정상적으로 처리되었습니다.');
          this.$store.dispatch('MENU/FETCH_PSNL_WORK_INFO'); // 개인근무정보조회 호출
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    // console.log('mainMixin.js OK');
    // console.log('this.$route.name : ' + this.$route.name);
    // console.log('routerConstants.Main : ' + routerConstants.Main);
    // console.log('GET_APPR_DOC_CNT : ' + this.GET_APPR_DOC_CNT);

    // console.log('route.name : ' + this.$route.name);
    // 메인&메뉴 데이터 조회
    if (this.$route.name === routerConstants.Main) {
      this.$store.dispatch('MENU/FETCH_MAIN_DATA');
    }
  },
};
